$mol_view_tree2_to_js_test_ex_bidi_fallback_foo $mol_object
	bar1? <=> bar2? 1
